import { render, staticRenderFns } from "./wine.vue?vue&type=template&id=09112cf8&scoped=true&"
import script from "./wine.vue?vue&type=script&lang=js&"
export * from "./wine.vue?vue&type=script&lang=js&"
import style0 from "./wine.vue?vue&type=style&index=0&id=09112cf8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09112cf8",
  null
  
)

export default component.exports